/* The recording page (FEWeek.dc.html at 1440, PhoneWeek.dc.html at 390), in the product's look. The
   Funding Engine's headings are Anton in capitals; the other looks keep their own heading font and
   case. Colours are the tokens file's, through the look's variables (product.css). */
.pp--fe { --rp-tint: var(--fe-green-12); --rp-edge: var(--fe-green-50); --rp-line-accent: var(--fe-green-60); --rp-gold: var(--fe-gold); --rp-gold-edge: var(--fe-gold-45); --rp-player-accent: var(--fe-green); --rp-row: var(--fe-surface); }
.pp--poyt { --rp-tint: var(--poyt-navy-07); --rp-edge: var(--poyt-orange); --rp-line-accent: var(--poyt-orange); --rp-gold: var(--poyt-orange); --rp-gold-edge: var(--poyt-line); --rp-player-accent: var(--poyt-orange-2); --rp-row: var(--poyt-paper); }
.pp--acc { --rp-tint: var(--acc-green-08); --rp-edge: var(--acc-green); --rp-line-accent: var(--acc-green); --rp-gold: var(--acc-green); --rp-gold-edge: var(--acc-rule); --rp-player-accent: var(--pcfl-accent); --rp-row: var(--acc-bg); }
.pp--master { --rp-tint: var(--shell-ink-04); --rp-edge: var(--shell-ink-20); --rp-line-accent: var(--shell-ink-20); --rp-gold: var(--shell-ink); --rp-gold-edge: var(--shell-ink-12); --rp-player-accent: var(--shell-gold); --rp-row: var(--shell-ink-03); }

.rp { display: flex; flex-direction: column; gap: 36px; min-width: 0; }
.rp-head { display: flex; flex-direction: column; gap: 10px; }
.rp-eyebrow { font-size: 14px; font-weight: 600; letter-spacing: 0.14em; text-transform: uppercase; color: var(--pp-soft); }
.rp-h1 { margin: 0; font-family: var(--pp-head-font); font-weight: var(--pp-heading-weight); font-size: 52px; line-height: 1.05; letter-spacing: -0.01em; }
.pp--fe .rp-h1 { font-size: 68px; line-height: 1; letter-spacing: 0.01em; text-transform: uppercase; }
.rp-h2 { margin: 0; font-family: var(--pp-head-font); font-weight: var(--pp-heading-weight); font-size: 26px; letter-spacing: 0.01em; line-height: 1.15; }
/* FEWeek and PhoneWeek give these headings no line height of their own, so Anton's normal (about 1.5) */
.pp--fe .rp-h2 { font-size: 28px; letter-spacing: 0.02em; text-transform: uppercase; line-height: normal; }
.pp--fe .rp-h2--side { font-size: 26px; }
.rp-h2--gold { color: var(--rp-gold); }
.rp-msg { margin: 0; font-size: 14px; line-height: 1.5; color: var(--pp-ink); }
.rp-loading { min-height: 50vh; }
.rp-layout { gap: 36px; }
.rp-layout .pp-band-col { gap: 28px; }

/* Parts of a module with several recordings */
.rp-parts { display: flex; gap: 10px; flex-wrap: wrap; margin-top: 6px; }
.rp-part { height: 36px; padding: 0 14px; border-radius: 18px; border: 1px solid var(--pp-round-line); display: inline-flex; align-items: center; font-size: 14px; font-weight: 600; text-decoration: none; }
.pp .rp-part { color: var(--pp-ink); }
.pp .rp-part--on { background: var(--pp-accent); border-color: var(--pp-accent); color: var(--pp-btn-fg); }
.pp .rp-part--locked { color: var(--pp-soft); }

/* The video and the chapters */
.rp-video { display: grid; grid-template-columns: minmax(0, 872fr) minmax(300px, 408fr); gap: 32px; align-items: start; }
.rp-video-main { display: flex; flex-direction: column; gap: 12px; min-width: 0; }
.pp-player {
  position: relative; width: 100%; aspect-ratio: 872 / 490; border-radius: 16px; background: var(--player-bg);
  overflow: hidden; border: 1px solid var(--on-dark-12);
}
.pp-player iframe { position: absolute; inset: 0; width: 100%; height: 100%; border: 0; }
.pp-play {
  position: absolute; left: 50%; top: 50%; width: 88px; height: 88px; margin: -44px 0 0 -44px; border-radius: 44px;
  border: none; background: var(--rp-player-accent); color: var(--fe-on-green); display: flex; align-items: center; justify-content: center;
}
.pp--poyt .pp-play { color: var(--on-dark); }
.pp-play:focus-visible { outline-color: var(--on-dark); }
.pp-player-recorded { position: absolute; left: 24px; top: 20px; font-size: 14px; font-weight: 600; color: var(--fe-text-80); }
.pp-player-foot { position: absolute; left: 24px; right: 24px; bottom: 20px; display: flex; flex-direction: column; gap: 10px; }
.pp-player-bar { display: block; height: 5px; border-radius: 3px; background: var(--on-dark-20); overflow: hidden; }
.pp-player-bar span { display: block; height: 5px; border-radius: 3px; background: var(--rp-player-accent); }
.pp-player-line { display: flex; justify-content: space-between; gap: 12px; font-size: 14px; color: var(--fe-text-85); }
.pp-player-watched { display: flex; align-items: center; gap: 6px; color: var(--rp-player-accent); font-weight: 700; flex-shrink: 0; }
.rp-sideways { font-size: 13px; color: var(--pp-soft); }
.rp-toast { padding: 12px 16px; border-radius: 10px; background: var(--pp-card); border: 1px solid var(--rp-edge); font-size: 14px; line-height: 1.5; color: var(--pp-ink); overflow-wrap: anywhere; }
.rp-ask-row { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding-top: 4px; }
.rp-ask-context { font-size: 14px; line-height: 1.5; color: var(--pp-soft); }
.rp-ask-btn {
  height: 40px; padding: 0 16px; border-radius: 10px; border: 1px solid var(--rp-line-accent); background: transparent;
  color: var(--pp-accent); font-weight: 700; font-size: 14px; display: flex; align-items: center; gap: 8px; flex-shrink: 0;
}
.pp--master .rp-ask-btn { color: var(--shell-ink); }
.rp-ask-btn[disabled] { opacity: 0.6; }
.rp-ask { padding: 18px; border-radius: 12px; background: var(--pp-card); border: 1px solid var(--pp-rule); display: flex; flex-direction: column; gap: 12px; }
.rp-ask textarea {
  height: 84px; padding: 10px 12px; border-radius: 9px; border: 1px solid var(--pp-round-line); background: var(--pp-bg);
  color: var(--pp-ink); font: inherit; font-size: 15px; line-height: 1.5; resize: none;
}
.pp--fe .rp-ask textarea { background: var(--on-dark-04); }
.rp-ask textarea::placeholder { color: var(--pp-soft); }
.rp-ask-foot { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.rp-ask-note { font-size: 13px; line-height: 1.5; color: var(--pp-soft); }
.rp-ask-send { height: 38px; padding: 0 16px; border-radius: 9px; border: none; background: var(--pp-btn-bg); color: var(--pp-btn-fg); font-weight: 700; font-size: 14px; flex-shrink: 0; }
.rp-sent { padding: 12px 16px; border-radius: 10px; background: var(--rp-tint); border: 1px solid var(--rp-edge); font-size: 14px; color: var(--pp-ink); }

.rp-chapters { border-radius: 16px; border: 1px solid var(--pp-rule); overflow: hidden; min-width: 0; }
.rp-chapters-head { padding: 18px 20px; border-bottom: 1px solid var(--pp-rule); font-family: var(--pp-head-font); font-weight: var(--pp-heading-weight); font-size: 20px; letter-spacing: 0.02em; }
.pp--fe .rp-chapters-head { text-transform: uppercase; }
.rp-ch { display: flex; align-items: center; gap: 10px; padding: 12px 14px 12px 20px; border-bottom: 1px solid var(--pp-rule-soft); }
.rp-ch:last-child { border-bottom: none; }
.rp-ch:hover { background: var(--on-dark-05); }
.pp--poyt .rp-ch:hover, .pp--acc .rp-ch:hover, .pp--master .rp-ch:hover { background: var(--rp-tint); }
.rp-ch--on, .rp-ch--on:hover { background: var(--rp-tint); }
.rp-ch-seek { flex-grow: 1; display: flex; align-items: flex-start; gap: 14px; background: none; border: none; padding: 0; color: var(--pp-ink); text-align: left; min-width: 0; }
.rp-ch-time { min-width: 62px; font-size: 14px; font-weight: 700; color: var(--pp-accent); font-variant-numeric: tabular-nums; }
.rp-ch-title { font-size: 15px; line-height: 1.4; font-weight: 500; }
.rp-ch-copy {
  width: 36px; height: 36px; border-radius: 8px; border: 1px solid var(--pp-round-line); background: transparent;
  color: var(--pp-soft); display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}

/* The session summary, the 5 things and the key learnings */
.rp-card { padding: 32px; border-radius: 16px; background: var(--pp-card); border: 1px solid var(--pp-rule); display: flex; flex-direction: column; gap: 14px; }
.rp-card--line { background: transparent; padding: 28px; gap: 16px; }
.pp--poyt .rp-card--line, .pp--acc .rp-card--line { background: var(--pp-card); }
.rp-summary-p { margin: 0; font-size: 17px; line-height: 1.65; color: var(--pp-ink); }
.rp-five { padding: 32px; border-radius: 16px; border: 1px solid var(--rp-gold-edge); display: flex; flex-direction: column; gap: 20px; }
.pp--poyt .rp-five, .pp--acc .rp-five, .pp--master .rp-five { background: var(--pp-card); }
.rp-five-row { display: flex; gap: 20px; align-items: flex-start; }
.rp-five-n { font-family: var(--pp-head-font); font-size: 34px; line-height: 1; color: var(--rp-gold); min-width: 28px; }
.pp--poyt .rp-five-n, .pp--acc .rp-five-n, .pp--master .rp-five-n { font-weight: 800; font-size: 30px; }
.rp-five-text { display: flex; flex-direction: column; gap: 4px; }
.rp-five-head { font-size: 18px; font-weight: 700; line-height: 1.4; }
.rp-five-body { font-size: 16px; line-height: 1.6; color: var(--pp-soft); }
.rp-learn { border-radius: 16px; border: 1px solid var(--pp-rule); overflow: hidden; }
.pp--poyt .rp-learn, .pp--acc .rp-learn, .pp--master .rp-learn { background: var(--pp-card); }
.rp-learn-head { padding: 22px 28px; border-bottom: 1px solid var(--pp-rule); display: flex; flex-direction: column; gap: 4px; }
.rp-learn-sub { font-size: 15px; color: var(--pp-soft); }
.rp-learn-row { border-bottom: 1px solid var(--pp-rule-soft); }
.rp-learn-row:last-child { border-bottom: none; }
.rp-learn-toggle {
  width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 18px 28px;
  background: none; border: none; color: var(--pp-ink); text-align: left;
}
.rp-learn-titles { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.rp-learn-title { font-size: 17px; font-weight: 700; line-height: 1.4; }
.pp--fe .rp-learn-title { line-height: normal; }
.rp-learn-range { font-size: 14px; color: var(--pp-soft); flex-shrink: 0; font-variant-numeric: tabular-nums; }
.rp-learn-body { padding: 0 28px 22px; display: flex; flex-direction: column; gap: 12px; }
.rp-learn-p, .rp-learn-p p { margin: 0; font-size: 16px; line-height: 1.65; color: var(--pp-soft); }
.rp-learn-p ul { margin: 6px 0 0; padding-left: 20px; display: flex; flex-direction: column; gap: 8px; }
.rp-learn-p li { font-size: 16px; line-height: 1.65; color: var(--pp-soft); }
.rp-stamp { background: none; border: none; padding: 0; font: inherit; color: var(--pp-accent); font-weight: 600; font-variant-numeric: tabular-nums; }
.pp--master .rp-stamp { color: var(--shell-ink); text-decoration: underline; }
.rp-stamp:hover { text-decoration: underline; }
.pp-chev { transition: transform 0.15s; flex-shrink: 0; color: var(--pp-soft); }
.pp-chev--open { transform: rotate(180deg); }

/* The weeks either side */
.rp-nav { display: flex; flex-direction: column; gap: 10px; padding-top: 8px; }
.rp-nav-row { display: flex; justify-content: space-between; gap: 20px; }
.rp-nav-card {
  display: flex; flex-direction: column; gap: 4px; padding: 18px 22px; border-radius: 14px; border: 1px solid var(--pp-rule);
  width: min(420px, 48%); text-decoration: none;
}
.pp .rp-nav-card { color: var(--pp-ink); }
a.rp-nav-card:hover { border-color: var(--pp-accent); }
.rp-nav-card--next { text-align: right; }
.rp-nav-card--empty { border: none; padding: 0; }
.rp-nav-word { font-size: 13px; font-weight: 600; letter-spacing: 0.12em; text-transform: uppercase; color: var(--pp-soft); }
.rp-nav-name { font-size: 16px; font-weight: 700; }
.rp-nav-teaser { font-size: 14px; line-height: 1.5; color: var(--pp-soft); }
.rp-reach { font-size: 13px; line-height: 1.55; color: var(--pp-soft); padding: 4px 2px 0; }
.pp .rp-reach a { color: var(--pp-accent); font-weight: 600; }
.pp--master .rp-reach a { color: var(--shell-ink); }

/* Homework, the worksheet and the prompts */
.rp-hw-head { display: flex; justify-content: space-between; align-items: baseline; gap: 12px; }
.rp-hw-count { font-size: 15px; font-weight: 700; color: var(--pp-accent); white-space: nowrap; }
.rp-hw-group { display: flex; flex-direction: column; gap: 14px; }
.rp-hw-heading { font-size: 13px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: var(--pp-soft); }
.rp-tick { display: flex; gap: 12px; align-items: flex-start; font-size: 15px; line-height: 1.55; cursor: pointer; }
.rp-tick input { width: 20px; height: 20px; margin: 2px 0 0; accent-color: var(--pp-accent); flex-shrink: 0; }
.rp-tick-text { color: var(--pp-ink); display: flex; flex-direction: column; gap: 2px; }
.rp-tick--done .rp-tick-text { color: var(--pp-soft); }
.rp-tick-time { font-size: 13px; color: var(--pp-soft); }
.rp-hw-note { margin: 4px 0 0; font-size: 15px; line-height: 1.6; color: var(--pp-soft); }
.rp-hw-note--own { margin: 0; color: var(--pp-ink); }
.rp-sheet-wrap { display: flex; flex-direction: column; gap: 12px; }
.rp-sheet-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 14px 16px; border-radius: 12px; background: var(--rp-row); }
.rp-sheet-row--locked { background: transparent; border: 1px solid var(--pp-rule); }
.rp-sheet-label { display: flex; align-items: center; gap: 12px; font-size: 15px; font-weight: 600; min-width: 0; }
.rp-sheet-icon { color: var(--pp-accent); display: flex; flex-shrink: 0; }
.rp-when { font-size: 13px; font-weight: 600; color: var(--pp-when); }
.rp-btn {
  height: 38px; padding: 0 14px; border-radius: 8px; border: 1px solid transparent; background: var(--pp-btn-bg); color: var(--pp-btn-fg);
  font-weight: 700; font-size: 14px; display: inline-flex; align-items: center; gap: 6px; white-space: nowrap; text-decoration: none; flex-shrink: 0;
}
.pp .rp-btn { color: var(--pp-btn-fg); }
.pp .rp-btn--done { background: transparent; border-color: var(--rp-line-accent); color: var(--pp-accent); }
.pp--master .rp-btn--done { color: var(--shell-ink); }
.pp .rp-btn--line { background: transparent; border-color: var(--pp-rule); color: var(--pp-ink); height: 44px; padding: 0 18px; }
.rp-prompts { display: flex; flex-direction: column; gap: 16px; }
.rp-prompt { padding: 22px; border-radius: 16px; border: 1px solid var(--pp-rule); display: flex; flex-direction: column; gap: 12px; }
.pp--poyt .rp-prompt, .pp--acc .rp-prompt, .pp--master .rp-prompt { background: var(--pp-card); }
.rp-prompt-head { display: flex; justify-content: space-between; align-items: center; gap: 12px; }
.rp-prompt-title { font-size: 16px; font-weight: 700; line-height: 1.4; }
.rp-prompt-toggle { flex-grow: 1; background: none; border: none; padding: 0; color: var(--pp-ink); text-align: left; }
.rp-copy {
  height: 36px; padding: 0 12px; border-radius: 8px; border: 1px solid var(--rp-line-accent); background: transparent;
  color: var(--pp-accent); font-weight: 700; font-size: 13px; flex-shrink: 0; display: inline-flex; align-items: center; gap: 6px; white-space: nowrap;
}
.pp--master .rp-copy { color: var(--shell-ink); }
.rp-prompt-text { padding: 14px 16px; border-radius: 10px; background: var(--rp-row); font-size: 14px; line-height: 1.6; color: var(--pp-ink); white-space: pre-line; overflow-wrap: anywhere; }
.pp-res-act { display: inline-flex; flex-direction: column; align-items: flex-end; gap: 6px; }
.pp-res-line { font-size: 13px; line-height: 1.5; color: var(--pp-ink); max-width: 260px; text-align: right; }
.pp-res-video { display: flex; flex-direction: column; gap: 10px; }
.pp-res-close { align-self: flex-start; height: 36px; padding: 0 14px; border-radius: 8px; border: 1px solid var(--pp-rule); background: transparent; color: var(--pp-ink); font-weight: 600; font-size: 13px; }

/* A week that hasn't opened yet */
.rp-locked { padding: 40px; border-radius: 16px; border: 1px solid var(--pp-rule); background: var(--pp-card); display: flex; flex-direction: column; gap: 16px; align-items: flex-start; }
.rp-locked-icon { color: var(--pp-lock); display: flex; }
.rp-locked-line { margin: 0; font-size: 17px; line-height: 1.6; color: var(--pp-ink); }

/* Below 1100px the chapters go under the video */
@media (max-width: 1099px) {
  .rp-video { grid-template-columns: minmax(0, 1fr); }
  .pp--fe .rp-h1 { font-size: 56px; }
}

/* A phone (PhoneWeek.dc.html) */
@media (max-width: 760px) {
  .rp { gap: 22px; }
  .rp-head { gap: 8px; }
  .rp-eyebrow { font-size: 12px; }
  .rp-h1, .pp--fe .rp-h1 { font-size: 40px; line-height: 1.02; }
  .rp-h2, .pp--fe .rp-h2, .pp--fe .rp-h2--side { font-size: 22px; }
  .rp-layout { gap: 22px; }
  .rp-video { gap: 22px; }
  .rp-video-main { gap: 10px; }
  .pp-player { aspect-ratio: 358 / 201; border-radius: 12px; }
  .pp-play { width: 64px; height: 64px; margin: -32px 0 0 -32px; border-radius: 32px; }
  .pp-player-foot { left: 12px; right: 12px; bottom: 10px; gap: 6px; }
  .pp-player-bar, .pp-player-bar span { height: 4px; border-radius: 2px; }
  .pp-player-line { font-size: 12px; }
  .rp-toast { padding: 12px 14px; font-size: 13px; }
  .rp-ask-row { flex-direction: column; align-items: stretch; gap: 10px; }
  .rp-ask-btn { justify-content: center; }
  .rp-ask-foot { flex-direction: column; align-items: stretch; }
  .rp-chapters { border-radius: 14px; }
  .rp-chapters-head { padding: 14px 16px; font-size: 18px; }
  .rp-ch { gap: 8px; padding: 10px 10px 10px 16px; }
  .rp-ch-seek { gap: 12px; padding: 4px 0; }
  .rp-ch-time { min-width: 54px; font-size: 13px; }
  .rp-ch-title { font-size: 14px; font-weight: 400; }
  .rp-ch-copy { width: 40px; height: 40px; }
  .rp-card { padding: 20px 16px; border-radius: 14px; }
  .rp-card--line { padding: 20px 16px; gap: 14px; }
  .rp-summary-p { font-size: 15px; }
  .rp-five { padding: 20px 16px; border-radius: 14px; gap: 16px; }
  .rp-five-row { gap: 14px; }
  .rp-five-n { font-size: 26px; min-width: 18px; }
  .rp-five-head { font-size: 15px; }
  .rp-five-body { font-size: 14px; line-height: 1.55; }
  .rp-learn { border-radius: 14px; }
  .rp-learn-head { padding: 16px; }
  .rp-learn-toggle { padding: 14px 16px; gap: 12px; }
  .rp-learn-title { font-size: 14px; font-weight: 600; }
  .rp-learn-range { font-size: 12px; }
  .rp-learn-body { padding: 0 16px 16px; }
  .rp-learn-p, .rp-learn-p p, .rp-learn-p li { font-size: 14px; line-height: 1.6; }
  .rp-tick { font-size: 14px; }
  .rp-tick input { width: 22px; height: 22px; margin-top: 1px; }
  /* PhoneWeek.dc.html draws the worksheet as its row alone */
  .rp-sheet { padding: 0; border: none; gap: 10px; }
  .rp-sheet > .rp-h2 { display: none; }
  .rp-sheet-row { padding: 16px; border-radius: 14px; }
  .rp-sheet-label { font-size: 14px; gap: 10px; }
  .rp-btn { height: 40px; }
  .rp-prompts { gap: 12px; }
  .rp-prompt { padding: 0; border-radius: 14px; gap: 0; overflow: hidden; }
  .rp-prompt-head { padding: 12px 12px 12px 16px; gap: 8px; }
  .rp-prompt-title { font-size: 14px; }
  .rp-copy { height: 38px; }
  .rp-prompt-text { margin: 0 12px 12px; padding: 12px 14px; font-size: 13px; }
  .rp-nav-card { width: auto; padding: 14px 16px; border-radius: 12px; }
  .rp-nav-word { font-size: 12px; }
  .rp-nav-name { font-size: 15px; }
  .rp-locked { padding: 24px 18px; }
  .pp-res-line { text-align: left; }
}
